<template>
	<div class="widget-card">
		<h2 v-if="widget" class="text-center">{{ widget.dashboardwidgets_title }}</h2>

		<LoadingSpinner v-if="loading" />
		<b-table
			v-else-if="tableItems.length > 0"
			:items="tableItems"
			:fields="fields"
			small
			bordered
		>
			<template #cell(label)="{ value }">
				<span class="d-block text-center">{{ value }}</span>
			</template>
			<template #cell(value)="{ value }">
				<span class="d-block text-center">{{ value }}</span>
			</template>
		</b-table>
		<span v-else class="d-block text-center">{{ $t('cards.widget.category_horse_empty') }}</span>
	</div>
</template>

<script type="text/javascript">
import DashboardMixin from '@/mixins/Dashboard.js'

export default {
	name: 'WidgetCategoryHorse',
	mixins: [DashboardMixin],
	props: ['widget'],
	data() {
		return {
			loading: true,
			tableItems: [],
			fields: [
				{ key: 'label', label: this.$t('cards.widget.col_category') },
				{ key: 'value', label: this.$t('cards.widget.col_horse_count') },
			],
		}
	},

	mounted() {
		this.loadData()
	},

	methods: {
		async loadData() {
			this.loading = true

			// Récupère la configuration du widget (résidence sélectionnée dans le dashboard)
			const config = this.widget.dashboardwidgets_config

			// L'API renvoie le nombre de chevaux par catégorie pour la résidence,
			// uniquement les catégories ayant au moins un cheval.
			this.tableItems = await this.getCategoryHorseStats(config.residence)
			this.loading = false
		},
	},

	components: {
		LoadingSpinner: () => import('GroomyRoot/components/Logos/LoadingSpinner_35'),
	},
}
</script>
